import { render, staticRenderFns } from "./HistoryCounter.vue?vue&type=template&id=58b7725a&"
import script from "./HistoryCounter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HistoryCounter.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports